import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: {},
};

const storeItemsSlice = createSlice({
  name: "storeItems",
  initialState,
  reducers: {
    setStoreItems(state, action) {
      state.items = action.payload;
    },
    clearStoreItems(state) {
      state.items = {};
    },
    updateStoreItem(state, action) {
      const updatedItem = action.payload;
      const typeKey = updatedItem.itemType;

      if (state.items[typeKey]) {
        state.items[typeKey] = state.items[typeKey].map((i) =>
          i.marketplaceStoreItemId === updatedItem.marketplaceStoreItemId
            ? updatedItem
            : i
        );
      }
    },
  },
});

export const { setStoreItems, clearStoreItems, updateStoreItem } =
  storeItemsSlice.actions;

export default storeItemsSlice.reducer;
